module.exports = __webpack_public_path__ + "img/next-arrow.ded9e6d2.svg";